import React from 'react';
import i18next from 'i18next';
import HttpApi from 'i18next-http-backend';
import { I18nextProvider } from 'react-i18next';
import log from '../util/log';

// For the short term, bundle translation into the main bundle. Long term these should likely live external
import en from './locales/en/translation.json';

const resources = {
  en: { translation: en },
};

// Create our i18n instance
i18next
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(HttpApi)
  // // detect user language
  // // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector)
  // init i18next. for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    fallbackNS: ['translation'],
    backend: {
      // for all available options read the backend's repository readme file
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    react: {
      // Must be false until Suspense is supported on the server side
      useSuspense: false,
      wait: true,
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    debug: process.env.NODE_ENV === 'development' && __BROWSER__,
    // This option is necessary to tell i18next to try loading missing resources via i18next-http-backend, otherwise no calls will be made if resources are defined.
    partialBundledLanguages: true,
    parseMissingKeyHandler: (missing: any) => {
      if (process.env.NODE_ENV === 'development' && __BROWSER__) {
        log.warn('MISSING TRANSLATION:', missing);
      }
      return missing;
    },
  });

i18next.languages = ['en'];

const CwI18nextProvider: React.FC<any> = ({ children }) => (
  <I18nextProvider i18n={i18next}>{children}</I18nextProvider>
);

export default React.memo(CwI18nextProvider);
